import React from "react";
import { Field, reduxForm, reset } from "redux-form";
import { connect } from "react-redux";
import lodash, { result } from "lodash";
import MUIDataTable from "mui-datatables";
import { plugins, crmValidator, loader, alert as customAlert } from "helpers";
import { reportActions } from "actions";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CloudDownload from "@material-ui/icons/CloudDownload";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { reportServices } from 'services';

import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";

import SweetAlert from "react-bootstrap-sweetalert";


const style = {};
const THEME = createMuiTheme(MTablestyles);
const FORM_NAME = "FORM_FILTER_TRUE_MONEY";


const ObjectDisplay = ({ data }) => {
    const [show, setShow] = React.useState(false);
  
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
  
    return (
      <div>
        <a onClick={handleShow} style={{ cursor: "pointer" }}>
          View
        </a>

        {show && (
        <SweetAlert
            title="Data"
            onConfirm={handleClose}
            // onCancel={handleClose}
            // showCancel
            style={{
                textAlign: 'left',
                maxHeight: '500px',
                overflowY: 'auto',
                width: '800px',
                // position: 'absolute', // ใช้ absolute เพื่อจัด SweetAlert
                left: '40%',
                top: '40%',
                // transform: 'translate(-50%, -50%)', // ทำให้ SweetAlert อยู่ตรงกลางจอ
                padding: '20px', // เพิ่มช่องว่างภายใน
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // เพิ่มเงาให้ดูสวยงาม
                borderRadius: '8px', // มุมมน
              }}
              confirmBtnStyle={{
                backgroundColor: '#f4b340', // สีพื้นหลังของปุ่ม
                color: 'white', // สีตัวอักษร
                fontSize: '18px', // ขนาดตัวอักษร
                padding: '10px 20px', // เพิ่มความใหญ่ของปุ่ม
                borderRadius: '5px', // มุมมน
                border: 'none', // ลบเส้นขอบ
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // เพิ่มเงา
                cursor: 'pointer', // เปลี่ยนเคอร์เซอร์เมื่อชี้ที่ปุ่ม
              }}
            >
            <pre>{JSON.stringify(data, null, 2)}</pre>
        </SweetAlert>
        )}
      </div>
    );
  };

class TrueMoneyReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 10,
            filter: {
                skip: 0,
                limit: 10,
                sortBy: "created_at",
                sortDir: "desc",
                keyword: "",
            },
            csvData: [],
        };
        this.csvLink = React.createRef();
        this.delayedCallback = lodash.debounce(this.getData, 800);
    }

    componentDidMount() {
        const { dispatch, trueMoneyReport } = this.props;
        const { tableFilter } = trueMoneyReport;
        
        dispatch(reportActions.getTrueMoneyList(tableFilter));
    }


    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(reset(FORM_NAME))
        dispatch({ type: "CLEAR_TRUE_MONEY_FILTER" })
    }


    handleSubmit(values) { 
        const { dispatch, trueMoneyReport } = this.props;
        const { tableFilter } = trueMoneyReport;
        let _tableFilter = {
            page: 0,
            skip: 0,
            limit: tableFilter.limit,
            sortBy: "created_at",
            sortDir: "desc",
            keyword: "",
            search: values
        }
        const resetTable = true;
        dispatch(reportActions.getTrueMoneyList(_tableFilter, resetTable));
    }


    clearFilter = () => {
        const { dispatch, trueMoneyReport } = this.props;
        const { tableFilter } = trueMoneyReport;
        let _tableFilter = {
            page: 0,
            skip: 0,
            limit: tableFilter.limit,
            sortBy: "created_at",
            sortDir: "desc",
        }
        dispatch(reset(FORM_NAME))
        dispatch({ type: "CLEAR_TRUE_MONEY_FILTER" })
        dispatch(reportActions.getTrueMoneyList(_tableFilter));
    };

    exportCSV() {
        const { trueMoneyReport, dispatch } = this.props;
        let { tableFilter, tableTotal } = trueMoneyReport;
        tableFilter.skip = 0;
        tableFilter.limit = tableTotal ? tableTotal : 100000;
        if (tableTotal > 30000) {
            customAlert(
                dispatch,
                "error",
                "Can not export data more than 30,000 rows"
            );
        } else {
            loader(dispatch, true);
            reportServices
                .downloadTrueMoney(tableFilter)
                .then((response) => {
                    loader(dispatch, false);
                })
                .catch((e) => {
                    this.setState({ csvData: [] });
                });
        }
    }

    
    getData(skip, limit, sortBy, sortDir, keyword) {
        const { dispatch, tableReload, trueMoneyReport } = this.props;
        let { tableFilter } = trueMoneyReport;
        let newFilter = tableFilter;
        
        if (!tableReload) {
            if (crmValidator.isEmptyValue(skip)) {
                newFilter.skip = 0;
            }

            if (crmValidator.isEmptyValue(limit)) {
                newFilter.limit = 10;
            }
            newFilter.page = skip;
            this.setState({
                rowsPerPage: limit,
            });
            skip = parseInt(limit) * parseInt(skip);

            newFilter.skip = skip;
            newFilter.limit = limit;

            if (!crmValidator.isEmptyValue(sortBy)) {
                newFilter.sortBy = sortBy;
            }

            if (!crmValidator.isEmptyValue(sortDir)) {
                newFilter.sortDir = sortDir;
            }

            if (!crmValidator.isEmptyValue(keyword)) {
                newFilter.keyword = keyword;
            } else {
                newFilter.keyword = "";
            }
        } else {
            newFilter = this.state.newFilter
        }

        // console.log(newFilter);
        dispatch(reportActions.getTrueMoneyList(newFilter));

        this.setState({
            isLoading: true,
            filter: newFilter,
        });
    }

    getRowData(rowIndex = 0) {
        const { trueMoneyReport } = this.props;
        const { tableData } = trueMoneyReport;
        const data = tableData;
        return data[rowIndex];
    }

    render() {
        const {
            FORM_FILTER_TRUE_MONEY,
            handleSubmit,
            trueMoneyReport
        } = this.props;
        const { rowsPerPage } = this.state;

        let startMaxDate = null;
        if (lodash.has(FORM_FILTER_TRUE_MONEY, "values.endDate")) {
            startMaxDate = FORM_FILTER_TRUE_MONEY.values.endDate;
        }

        let endMinDate = null;
        if (lodash.has(FORM_FILTER_TRUE_MONEY, "values.startDate")) {
            endMinDate = FORM_FILTER_TRUE_MONEY.values.startDate;
        }
        
        
        let lineRegisterTypeList = [{
            value: "",
            label: "All"
        },{
            value: "new",
            label: "New"
        },{
            value: "transferFromAgency",
            label: "Transfer (Agency)"
        },{
            value: "transferFromOnline",
            label: "Transfer (Online)"
        }];

        let packageList = [{
            value: "",
            label: "All"
        },{
            value: "LINEOA_BASIC1280",
            label: "Basic"
        },{
            value: "LINEOA_PRO1780",
            label: "Pro"
        }];

        let typeList = [{
            value: "",
            label: "All"
        },{
            value: "บุคคลธรรมดา",
            label: "บุคคลธรรมดา"
        },{
            value: "นิติบุคคล",
            label: "นิติบุคคล"
        }];

        const { tableData, tableTotal, tableFilter } = trueMoneyReport;
        const columns = [
            {
                name: "created_at",
                label: "Date/Time",
                options: {
                    customBodyRender: (value) =>
                    value ? plugins.datetimeFormat(value, "fulldatetime") : "",
                },
            },
            {
                name: "lineRegisterType",
                label: "LINE OA Type",
                options: {
                    // filter: false, 
                    // sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if(rowData.lineRegisterType === 'transferFromAgency'){
                            return 'Transfer (Agency)'
                        } else if (rowData.lineRegisterType === 'transferFromOnline') {
                            return 'Transfer (Online)'
                        } else {
                            return 'New'
                        }
                    }
                }
            },
            {
                name: "lineDisplayName",
                label: "Display Name / Basic ID",
                options: {
                    // filter: false, 
                    // sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return lodash.get(rowData, 'lineDisplayName','')+","+lodash.get(rowData, 'lineOaId','')
                    }
                }
            },
            {
                name: "package",
                label: "Price Plan",
                options: {
                    // filter: false, 
                    // sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return (lodash.get(rowData, 'package') == 'LINEOA_PRO1780' ? "PRO" : "BASIC")
                    }
                }
            },
            {
                name: "type",
                label: "Application Type",
                // options: {
                //     filter: false, 
                //     sort: false,
                //     customBodyRender: (value, tableMeta) => {
                //         const rowIndex = tableMeta.rowIndex;
                //         const rowData = this.getRowData(rowIndex);
                //             return (lodash.get(rowData, 'type') == 'corporation' ? "นิติบุคคล" : "บุคคลธรรมดา")
                //     }
                // }
            },
            {
                name: "companyName",
                label: "Company Name",
            },
            {
                name: "email",
                label: "Applicant E-mail",
            },
            {
                name: "firstName",
                label: "Applicant Name",
                options: {
                    // filter: false, 
                    // sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return (rowData.firstName ? lodash.get(rowData, 'firstName')+" "+lodash.get(rowData, 'lastName') : "")
                    }
                }
            },
            {
                name: "premiumId1",
                label: "Premium ID",
                options: {
                    // filter: false, 
                    // sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        let val = lodash.get(rowData, 'premiumId1', '')
                        if(rowData.premiumId2){
                            val += ", " + rowData.premiumId2
                        }
                        if(rowData.premiumId3){
                            val += ", " + rowData.premiumId3
                        }
                        if(rowData.premiumId4){
                            val += ", " + rowData.premiumId4
                        }
                        return val
                    }
                }
            },
            {
                name: "Doc 1",
                label: "Doc 1",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if (rowData.docPath1) {
                            return <a href={rowData.docPath1} target="_blank">Link</a>
                        } else {
                            return null
                        }
                    }
                }
            },
            {
                name: "Doc 2",
                label: "Doc 2",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if (rowData.docPath2) {
                            return <a href={rowData.docPath2} target="_blank">Link</a>
                        } else {
                            return null
                        }
                    }
                }
            },
            {
                name: "Create order recurring",
                label: "Create order recurring",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if (rowData.createOrderRecurring) {
                            return <ObjectDisplay data={rowData.createOrderRecurring} />
                        } else {
                            return null
                        }
                    }
                }
            },
            {
                name: "Merchant notification log",
                label: "Merchant notification log",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if (Object.keys(rowData.merchantNotificationLog).length > 0) {
                            return <ObjectDisplay data={rowData.merchantNotificationLog} />
                        } else {
                            return null
                        }
                    }
                }
            },
            {
                name: "Query ISV payment transaction",
                label: "Query ISV payment transaction",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if (rowData.queryIsvPaymentTransaction) {
                            return <ObjectDisplay data={rowData.queryIsvPaymentTransaction} />
                        } else {
                            return null
                        }
                    }
                }
            }
        ];
        const options = {
            serverSide: true,
            count: tableTotal ? tableTotal : 0,
            page: tableFilter ? tableFilter.page : 0,
            rowsPerPage: rowsPerPage,
            fixedHeader: true,
            selectableRows: "none",
            print: false,
            customToolbar: () => {
                return (
                    <>
                        {plugins.isHasPermission("report[true_money_line_register]", "export") && plugins.isHasPackageFeatures('export') &&(
                            <Tooltip title='Export CSV'>
                                <IconButton
                                    id='button-trueMoneyRegisterTable-exportCsv'
                                    className=''
                                    onClick={this.exportCSV.bind(this)}>
                                    <CloudDownload />
                                </IconButton>
                            </Tooltip>
                        )}
                    </>
                );
            },
            download: false,
            filter: false,
            responsive: "scroll",
            rowsPerPageOptions: [1, 5, 10, 20],
            onTableChange: (action, tableState) => {
                let skip,
                    limit,
                    sortBy,
                    sortDir,
                    keyword = "";

                if (tableState.page !== null) {
                    skip = tableState.page;
                }

                if (tableState.rowsPerPage !== null) {
                    limit = tableState.rowsPerPage;
                }

                if (tableState.activeColumn !== null) {
                    sortBy = tableState.columns[tableState.activeColumn].name;
                }
                if (tableState.announceText !== null) {
                    sortDir =
                        tableState.announceText.search("descending") !== -1
                            ? "desc"
                            : "asc";
                }
                if (tableState.searchText !== null || action === "search") {
                    keyword = tableState.searchText;
                    this.delayedCallback(skip, limit, sortBy, sortDir, keyword);
                }
                let actionList = ["changePage", "sort", "changeRowsPerPage"];
                if (actionList.indexOf(action) !== -1) {
                    this.getData(skip, limit, sortBy, sortDir, keyword);
                }
            },
        };
        return (
            <div id='TrueMoneyReport'>
                <form
                    name={FORM_NAME}
                    onSubmit={handleSubmit(this.handleSubmit.bind(this))}
                >
                    <GridContainer>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="startDate"
                                component={CustomDatePicker}
                                type="text"
                                maxDate={startMaxDate}
                                labelText="Start Date"
                                dateFormat="DD-MMM-YY"
                                timeFormat="HH:mm:ss"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="endDate"
                                minDate={endMinDate}
                                maxDate={new Date()}
                                component={CustomDatePicker}
                                type="text"
                                labelText="End Date"
                                dateFormat="DD-MMM-YY"
                                timeFormat="HH:mm:ss"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="lineRegisterType"
                                component={CustomSelect}
                                type="text"
                                labelText="Line OA Type"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                optionsList={lineRegisterTypeList}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="lineDisplayName"
                                component={CustomInput}
                                type="text"
                                labelText="Display Name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="lineOaId"
                                component={CustomInput}
                                type="text"
                                labelText="Basic ID"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="package"
                                component={CustomSelect}
                                type="text"
                                labelText="Price Plan"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                optionsList={packageList}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="type"
                                component={CustomSelect}
                                type="text"
                                labelText="Application Type"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                optionsList={typeList}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="companyName"
                                component={CustomInput}
                                type="text"
                                labelText="Company Name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="name"
                                component={CustomInput}
                                type="text"
                                labelText="Applicant Name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="email"
                                component={CustomInput}
                                type="text"
                                labelText="Applicant E-mail"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="premiumId"
                                component={CustomInput}
                                type="text"
                                labelText="Premium ID"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        
                        <GridItem xs={12} sm={6} md={3} lg={3}>
                            <Button
                                id="button-trueMoneyReport-clear"
                                onClick={this.clearFilter}
                                style={{ marginRight: "10px", marginTop: "25px" }}
                                size="sm"
                                color="white"
                            >
                                Clear
                            </Button>
                            <Button
                                type="submit"
                                id="button-trueMoneyReport-submit"
                                style={{ marginTop: "25px" }}
                                size="sm"
                                color="primary"
                            >
                                Submit
                            </Button>
                        </GridItem>
                    </GridContainer>
                </form>
                
                <MuiThemeProvider theme={THEME}>
                    <MUIDataTable
                        key={trueMoneyReport.tableKey}
                        data={tableData ? tableData : []}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { FORM_FILTER_TRUE_MONEY } = state.form;
    const { trueMoneyReport } = state.report;
    const { merchantSetting, package_features } = state.authentication;

    return {
        FORM_FILTER_TRUE_MONEY,
        trueMoneyReport,
        merchantSetting,
        package_features
    };
}

const connectedComponent = connect(mapStateToProps)(TrueMoneyReport);

export default reduxForm({
    form: FORM_NAME,
})(withStyles(style)(connectedComponent));
